import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NotesComponent } from './notes.component';
import { NoteDialogComponent } from './note-dialog/note-dialog.component';
import { NoteDetailsComponent } from './note-details/note-details.component';
import { MultiModulePickerModule } from '../multi-module-picker/multi-module-picker.module';
import { FileUploaderModule } from '../file-uploader/file-uploader.module';

@NgModule({
  declarations: [
    NotesComponent,
    NoteDetailsComponent,
    NoteDialogComponent
  ],
  imports: [
    SharedModule,
    MultiModulePickerModule,
    FileUploaderModule
  ],
  exports: [
    NotesComponent,
    NoteDetailsComponent,
    NoteDialogComponent
  ]
})
export class NotesModule { }
